// v0.6.12 A5-27 — the country lists, shared.
//
// These lived privately in components/ClientEditForm.jsx, so every other
// box that asks for a country (the registrations table, the add-
// registration dialog, the work-country resolver) was a bare two-letter
// text input — free to type "UK", "D" or "GE" for Germany. A country is
// a closed set; it is picked, not written.
//
// EU_GB_CHOICES first, because nearly every client is EU or UK, then the
// full ISO-3166-1 alpha-2 remainder. The full list, not EU-27 only:
// ClientEditForm's own history (v0.6.8) is a non-EU client who had
// nowhere to go when the list was short.

export const EU_ISO2_LIST = [
  "AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR",
  "GR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL",
  "PT", "RO", "SE", "SI", "SK",
];
export const EU_ISO2 = new Set(EU_ISO2_LIST);

export const EU_GB_CHOICES = ["GB", ...EU_ISO2_LIST];

export const REST_OF_WORLD_CHOICES = [
  "AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS",
  "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BF", "BH", "BI", "BJ",
  "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY",
  "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM",
  "CN", "CO", "CR", "CU", "CV", "CW", "CX", "DJ", "DM", "DO", "DZ",
  "EC", "EG", "EH", "ER", "ET", "FJ", "FK", "FM", "FO", "GA", "GD",
  "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GS",
  "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HT", "ID", "IL", "IM",
  "IN", "IO", "IQ", "IR", "IS", "JE", "JM", "JO", "JP", "KE", "KG",
  "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB",
  "LC", "LI", "LK", "LR", "LS", "LY", "MA", "MC", "MD", "ME", "MF",
  "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS",
  "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG",
  "NI", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG",
  "PH", "PK", "PM", "PN", "PR", "PS", "PW", "PY", "QA", "RE", "RS",
  "RU", "RW", "SA", "SB", "SC", "SD", "SG", "SH", "SJ", "SL", "SM",
  "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD",
  "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT",
  "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC",
  "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM",
  "ZW",
];

export const ALL_COUNTRY_CHOICES = [...EU_GB_CHOICES, ...REST_OF_WORLD_CHOICES];

// "DE" -> "Germany". Same approach as lib/serverErrorText.js; falls back
// to the code where Intl.DisplayNames is unavailable.
export const countryName = (cc) => {
  if (!cc) return "";
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(cc) || cc;
  } catch {
    return cc;
  }
};

// "DE — Germany": the code stays visible because it is what the operator
// sees on invoices and returns.
export const countryOptionLabel = (cc) => {
  const name = countryName(cc);
  return name && name !== cc ? `${cc} — ${name}` : cc;
};

// A stored value that is not on the list (an old typed "UK", say) must
// still show as the current value rather than silently reading as blank,
// so the picker keeps it as an extra, last option until it is changed.
export const withCurrent = (choices, current) => {
  const cc = (current || "").toUpperCase();
  return cc && !choices.includes(cc) ? [...choices, cc] : choices;
};
